import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

const STORAGE_KEY = "pp_announcement_dismissed";

export default function AnnouncementBar() {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    setDismissed(stored === "true");
  }, []);

  if (user || dismissed) return null;

  const handleDismiss = () => {
    setDismissed(true);
    localStorage.setItem(STORAGE_KEY, "true");
  };

  return (
    <div className="bg-gradient-to-r from-primary to-[#0a1e4a] text-white text-center py-1.5 px-4 relative">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-2 text-xs sm:text-sm">
        <svg className="w-4 h-4 text-accent-300 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" /></svg>
        <span>
          <span className="font-semibold">Free account + included starter software</span> — credential review typically takes 1–2 business days.{" "}
          <Link to="/software" className="underline underline-offset-2 font-semibold text-accent-300 hover:text-accent-200">
            See how it works
          </Link>
        </span>
        <button onClick={handleDismiss} className="absolute right-3 top-1/2 -translate-y-1/2 text-white/60 hover:text-white p-1" aria-label="Dismiss">
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
        </button>
      </div>
    </div>
  );
}
